import { Theme, makeStyles } from "@material-ui/core"

export const useModalStyles = makeStyles((theme: Theme) => ({
    btnGroup: {
        width: "100%",
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
        marginTop: theme.spacing(4),
    },
    cancelBtn: {
        backgroundColor: "#f44336",
        color: "white",
        "&:hover": {
            backgroundColor: "#f44336",
        },
    },
    confirmBtn: {
        backgroundColor: "#4caf50",
        color: "white",
        "&:hover": {
            backgroundColor: "#4caf50",
        },
    },
    timeBlock: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        marginTop: 20,
    },
    input: {
        width: "100%",
        marginTop: 10,
    },
}))
